import React from 'react';
import T from 'prop-types';
// styles
import classnames from 'classnames/bind';
import styles from './TextArea.mod.css';

const cn = classnames.bind(styles);

const TextArea = ({
  className = '',
  secondary,
  invalid,
  color,
  ...otherProps
}) => (
  <div className={cn(styles.inputWrapper, className, { secondary })}>
    <textarea className={cn(styles.textarea, { invalid })} {...otherProps} />
    <span
      className={styles.border}
      style={color ? { backgroundColor: color } : undefined}
    />
  </div>
);

TextArea.propTypes = {
  className: T.string,
  color: T.string,
  secondary: T.bool,
  invalid: T.bool
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea/TextArea.jsx